import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardBorderRadius, CardSize } from '@freelancer/ui/card';
import { Margin } from '@freelancer/ui/margin';
import { HireMeUser } from 'app/hire-me/hire-me.types';
import * as Rx from 'rxjs';
import {
  AwardProjectHireMeState,
  AwardProjectModel,
} from '../user-profile-award-project.types';
import { SplitButtonClickEvent } from '../user-profile-hire-me/user-profile-hire-me.component';

@Component({
  selector: 'app-user-profile-hire-me-action',
  template: `
    <app-user-profile-hire-me-action-state
      [awardProjectHireMeState$]="awardProjectHireMeState$"
    >
      <ng-container loading-state>
        <ng-template [ngTemplateOutlet]="loading"></ng-template>
      </ng-container>

      <ng-container award-project-state>
        <ng-container
          *ngIf="awardProjectBid$ | flAsync as awardProjectModel; else loading"
        >
          <app-user-profile-award-project-sidebar
            [awardProjectModel]="awardProjectModel"
            [hireMeUser$]="hireMeUser$"
            [isDeloitteUserProfile$]="isDeloitteUserProfile$"
          >
          </app-user-profile-award-project-sidebar>
        </ng-container>
      </ng-container>

      <ng-container hire-me-state>
        <app-user-profile-hire-me
          [hireMeUser$]="hireMeUser$"
          [isLoggedIn$]="isLoggedIn$"
          [profileDisplayName$]="profileDisplayName$"
          (splitButtonClick)="splitButtonClick.emit($event)"
        ></app-user-profile-hire-me>
      </ng-container>

      <ng-template #loading>
        <fl-card
          class="DarkCard"
          [borderRadius]="CardBorderRadius.LARGE"
          [edgeToEdge]="true"
          [size]="CardSize.SMALL"
        >
          <fl-loading-text [rows]="1"></fl-loading-text>
          <fl-hr></fl-hr>
          <fl-loading-text [rows]="2"></fl-loading-text>
          <fl-loading-text [rows]="2"></fl-loading-text>
        </fl-card>
      </ng-template>
    </app-user-profile-hire-me-action-state>
  `,
  styleUrls: ['./user-profile-hire-me-action.component.scss'],
})
export class UserProfileHireMeActionComponent {
  CardBorderRadius = CardBorderRadius;
  CardSize = CardSize;
  Margin = Margin;

  @Input() awardProjectBid$: Rx.Observable<AwardProjectModel>;
  @Input() awardProjectHireMeState$: Rx.Observable<AwardProjectHireMeState>;
  @Input() hireMeUser$: Rx.Observable<HireMeUser>;
  @Input() isDeloitteUserProfile$: Rx.Observable<boolean>;
  @Input() isLoggedIn$: Rx.Observable<boolean>;
  @Input() profileDisplayName$: Rx.Observable<string>;

  @Output() splitButtonClick = new EventEmitter<SplitButtonClickEvent>();
}
